import { post } from "../../service/api";

const CreateMerchant = async (data) => {
  try {
    const response = await post(`/merchant`, data);
    return response.data;
  } catch (error) {
    console.error("Error createMerchant:", error);
    return null;
  }
};

export default CreateMerchant;
